const initialState = false;

const forgetPassword = (state = initialState, action) => {
    switch (action.type) {
        case "openForgetPassword": return true;
        case "closeForgetPassword": return false;
        default: return state;
    }
}
export default forgetPassword;